import { useTrackerContext, useTrackerDetailsQuery } from '@buildwise/libs/trackers';
import { Box } from '@mui/material';
import AddTaskForm from './AddTaskForm';
import EditTask from './EditTask';
import useAddTaskForm from '@buildwise/libs/trackers/hooks/useAddTaskForm';
import { FormProvider } from 'react-hook-form';

function TrackerForm() {
  const {
    state: { isOpenedTaskForm, selectedTask, trackerId },
  } = useTrackerContext();
  const { tracker } = useTrackerDetailsQuery({
    trackerId,
    shouldFetch: false,
  });
  const { taskForm, taskFields, onSubmit } = useAddTaskForm({
    trackerFieldsConfigName: tracker?.configNameForInputFields || '',
    isEditing: !!selectedTask,
    taskData: selectedTask,
  });

  return (
    <>
      {(isOpenedTaskForm || selectedTask) && (
        <FormProvider {...taskForm}>
          <Box
            sx={(theme) => ({
              position: 'fixed',
              top: 0,
              bottom: 0,
              right: 0,
              width: 800,
              backgroundColor: theme.palette.custom.white,
              borderLeft: `1px solid ${theme.palette.custom.divider}`,
              boxShadow: `-6px 0 12px 0 ${theme.palette.custom.boxShadow}`,
              overflow: 'auto',
              zIndex: 99,
            })}
          >
            {isOpenedTaskForm ? (
              <AddTaskForm taskFields={taskFields} onSubmit={onSubmit} />
            ) : (
              <EditTask taskFields={taskFields} onSubmit={onSubmit} />
            )}
          </Box>
        </FormProvider>
      )}
    </>
  );
}

export default TrackerForm;
